import { useTranslation } from "react-i18next";
import { ProductErrorState } from "../../components/common/ProductErrorState.js";
import { instagramOauthErrorMessageKey } from "../instagram/instagram-popup-errors.js";
import {
  facebookOauthErrorMessageKey,
  oauthEnvironmentMessageKey,
} from "../platforms/oauth-popup-errors.js";

export function ChannelConnectNotice({
  platform,
  code,
  onDismiss,
}: {
  platform: "instagram" | "facebook";
  code: string;
  onDismiss: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const platformTurnedOff = code === "PLATFORM_NOT_ENABLED";
  const environment = !platformTurnedOff && oauthEnvironmentMessageKey(platform, code) != null;
  const descriptionKey =
    platform === "instagram"
      ? instagramOauthErrorMessageKey(code)
      : facebookOauthErrorMessageKey(code);

  return (
    <ProductErrorState
      layout="inline"
      testId={`channels-${platform}-connect-error`}
      title={
        platformTurnedOff
          ? t("channels.platformDisabledTitle")
          : environment
            ? t(platform === "instagram" ? "instagram.disabled.title" : "facebook.disabled.title")
            : t(platform === "instagram" ? "instagram.popupError.generic" : "facebook.popupError.generic")
      }
      description={t(descriptionKey)}
      onDismiss={onDismiss}
      dismissLabel={t(platform === "instagram" ? "instagram.dismiss" : "facebook.popupError.retry")}
    />
  );
}
